// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"02a7a7e8","239":"b6e71f4c","453":"5c757a70","667":"c1c98130"}[chunkId] + ".chunk.js";
};